import { render, staticRenderFns } from "./OrderClientDisplay.vue?vue&type=template&id=7e173070&"
import script from "./OrderClientDisplay.vue?vue&type=script&lang=js&"
export * from "./OrderClientDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports